import React from 'react';
import { Container, Box, Typography, Breadcrumbs, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { NavigateNext } from '@mui/icons-material';
import { ItemIssueDetails } from '../../components/ItemIssue/ItemIssueDetails';

export const InvItemIssueDetailsPage = () => {
  return (
    <Container maxWidth="xl">
      <Box sx={{ mb: 4 }}>
        <Breadcrumbs separator={<NavigateNext fontSize="small" />} aria-label="breadcrumb">
          <Link
            component={RouterLink}
            to="/dashboard"
            underline="hover"
            color="inherit"
          >
            Dashboard
          </Link>
          <Link
            component={RouterLink}
            to="/item-issues"
            underline="hover"
            color="inherit"
          >
            Item Issues
          </Link>
          <Typography color="text.primary">Details</Typography>
        </Breadcrumbs>
      </Box>

      <ItemIssueDetails />
    </Container>
  );
};
